export const isBurnConfirmed = (x) => {
    return x.renVMHash !== undefined;
};
export const isReleased = (x) => {
    return x.renResponse !== undefined;
};
export const isBurnCompleted = (x) => {
    return x.completedAt !== undefined;
};
export const isBurnErroring = (x) => {
    return x.error !== undefined;
};
//# sourceMappingURL=burn.js.map